  export function transformErrorResponse(errors = {}) {
      const transformedErrors = Object.fromEntries(
        Object.entries(errors).map(([key, value]) => [
          key,
          Array.isArray(value) ? value[0] : value // Take the first element if it's an array, else keep it as is
        ])
      );

      return transformedErrors;
  }